import styled from 'styled-components';
import { spacing } from 'ui/theme';

type ControlGroupProps = {
  /**
   * What is the purpose of the control group, e.g. "Group of controls for filtering campaigns"
   */
  'aria-label': string;
};

export const ControlGroup = styled.div<ControlGroupProps>`
  margin: 0;
  padding: 0;
  width: fit-content;
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;
